import React from 'react';
import IconFromPath from '../IconFromPath/IconFromPath';
import Rectangle from './Rectangle';

const RectangleIcon = props => (
    <IconFromPath {...props} Path={Rectangle} />
);

export default RectangleIcon;
